<template>
  <div v-if="hasData" class="c-pager">
    <p class="c-pager__status">
      {{ start | separateNumber }}-{{ end | separateNumber }}を表示 /
      {{ total | separateNumber }}
    </p>
    <div v-if="hasPages" class="c-pager__btns">
      <Button variant="dark" :disabled="isDisabledPrev" @click="clickPrev">
        ←
      </Button>
      <Button variant="dark" :disabled="isDisabledNext" @click="clickNext">
        →
      </Button>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button';

export default {
  model: {
    prop: 'offset',
    event: 'change'
  },
  props: {
    limit: {
      type: Number,
      required: true,
      default: 0
    },
    offset: {
      type: Number,
      required: true,
      default: 0
    },
    total: {
      type: Number,
      required: true,
      default: 0
    }
  },
  components: {
    Button
  },
  computed: {
    start() {
      return this.offset + 1;
    },
    end() {
      const end = this.offset + this.limit;
      return end > this.total ? this.total : end;
    },
    hasData() {
      return this.total > 0;
    },
    hasPages() {
      return this.total > this.limit;
    },
    isDisabledNext() {
      return this.end >= this.total;
    },
    isDisabledPrev() {
      return this.offset <= 0;
    }
  },
  methods: {
    clickNext() {
      if (this.isDisabledNext) {
        return;
      }
      const offset = this.offset + this.limit;
      this.$emit('change', offset);
    },
    clickPrev() {
      if (this.isDisabledPrev) {
        return;
      }
      const offset = this.offset - this.limit;
      this.$emit('change', offset);
    }
  }
};
</script>
